type NCLICK_TYPE = {
  [key: string]: string
}

export const NCLICK = {
  MY_HOUSE: {
    LOAN_RECOMMEND: {
      전세만기: 'info.expiryloanlease',
      월세만기: 'info.expirymloanlease',
    },
    FOOTER: {
      LOGIN: 'fot.login',
      LOGOUT: 'fot.logout',
      ALL_SERVICE: 'fot.sitemap',
      HELP: 'fot.help',
      TERMS: 'fot.terms',
      PERSONAL_DATA: 'fot.personaldata',
      NAVER_FINANCIAL: 'fot.naverfinancial',
      BUSINESS_INFO: 'fot.bizinfo',
      INQUIRY: 'fot.inquires',
      OPEN_SOURCE: 'fot.opensource',
    },
    SEARCH: {
      COMPLEX_TAB: 'src.building',
      ADDRESS_TAB: 'src.address',
      COMPLEX_SEARCH: 'src.buildingsearch',
      ADDRESS_SEARCH: 'src.addresssearch',
      NPAY_DELIVERY_SELECT: 'src.npayselect',
      RECENT_DELIVERY_SELECT: 'src.recentselect',
      CLOSE: 'src.close',
    },
    REGISTER: {
      ADDRESS_CHANGE: 'reg.address',
      REALESTATE_TYPE: 'reg.hometype',
      REALESTATE_TYPE_SELECT: {
        A01: 'reg.hometype1',
        A02: 'reg.hometype2',
        C02: 'reg.hometype3',
        C03: 'reg.hometype4',
        D05: 'reg.hometype5',
        D02: 'reg.hometype6',
        D03: 'reg.hometype7',
      } as NCLICK_TYPE,
      PYEONG_SELECT: 'reg.pyselect',
      DEAL: 'reg.sell',
      LEASE: 'reg.rent',
      RENT: 'reg.monthly',
      INPUT: {
        DEAL_PRICE: 'reg.sellprice',
        DEAL_DEPOSIT: 'reg.selldeposit',
        DEAL_DATE: 'reg.selldate',
        LEASE_DEPOSIT: 'reg.rentdeposit',
        LEASE_MOVE_DATE: 'reg.rentmovedate',
        LEASE_EXPIRE_DATE: 'reg.rentexpirydate',
        RENT_DEPOSIT: 'reg.monthlydeposit',
        RENT_PRICE: 'reg.monthlyprice',
        RENT_MOVE_DATE: 'reg.monthlymovedate',
        RENT_EXPIRE_DATE: 'reg.monthlyexpirydate',
      },

      TERM: {
        ALL: 'reg.allterms',
        COLLECT: 'reg.terms1',
        DISCLOSURE: 'reg.terms2',
        COLLECT_MORE: 'reg.terms1more',
        DISCLOSURE_MORE: 'reg.terms2more',
      },
      COMPLETE: 'reg.complete',
      CLOSE: 'reg.close',
    },
    RESTRICT: {
      AGE: 'pro.14',
      ID: 'pro.id',
    },
    ADD_HOME_RESULT_AUTHENTICATION_GUIDE: {
      OWNER: 'con*s.myhouse',
      RESIDENT: 'con*s.tenant',
      BUILDING: 'con*s.building',
      OWNER_NO_INFO: 'con*s.myhousenoinfo',
      RESIDENT_NO_INFO: 'con*s.tenantnoinfo',
      OWNER_AGAIN_LATER: 'con*s.myhouseclose',
      RESIDENT_AGAIN_LATER: 'con*s.tenantclose',
      BUILDING_AGAIN_LATER: 'con*s.buildingclose',
      OWNER_NO_INFO_AGAIN_LATER: 'con*s.myhousenoinfoclose',
      RESIDENT_NO_INFO_AGAIN_LATER: 'con*s.tenantnoinfoclose',
      CLOSE: 'con*s.close',
    },
    AUTHENTICATION: {
      SELECT_AUTH_TYPE: {
        OWNER: 'con*t.owner',
        RESIDENT: 'con*t.tenant',
        CLOSE: 'con*t.close',
      },
      OWNER: {
        PUSH: 'own.push',
        APPLY: 'own.apply',
        BACK: 'own.back',
        CLOSE: 'own.close',
      },
      OWNER_REALNAME: {
        IDENTIFICATION: 'own*p.identification',
        CANCEL: 'own*p.cancel',
      },
      RESIDENT_NPAY: {
        DONE: 'ten*p.done',
      },
      SELECT_RESIDENT_AUTH_TYPE: {
        FEE: 'ten.bill',
        PACKAGE: 'ten.post',
        CLOSE: 'ten.close',
        MOBILE: 'ten.mobile',
      },
      RESIDENT_TERM: {
        COLLECT: 'ten*t.terms',
        COLLECT_MORE: 'ten*t.termsmore',
        PUSH: 'ten*t.push',
        NEXT: 'ten*t.next',
        BACK: 'ten*t.back',
        CLOSE: 'ten*t.close',
      },
      RESIDENT_FEE: {
        ATTACH: 'bill.start',
        GUIDE: 'bill.fileguide',
        BACK: 'bill.back',
        CLOSE: 'bill.close',
      },
      RESIDENT_FEE_CONFIRM: {
        IMAGE_VIEWER: 'bill*c.img',
        GUIDE: 'bill*c.fileguide',
        APPLY: 'bill*c.apply',
        AGAIN: 'bill*c.again',
        BACK: 'bill*c.back',
        CLOSE: 'bill*c.close',
      },
      ATTACH_CAUTION_POPUP: {
        START: 'teng*p.start',
        CLOSE: 'teng*p.close',
      },
      RESIDENT_PACKAGE: {
        ATTACH: 'post.start',
        GUIDE: 'post.fileguide',
        BACK: 'post.back',
        CLOSE: 'post.close',
      },
      RESIDENT_PACKAGE_CONFIRM: {
        IMAGE_VIEWER: 'post*c.img',
        GUIDE: 'post*c.fileguide',
        APPLY: 'post*c.apply',
        AGAIN: 'post*c.again',
        BACK: 'post*c.back',
        CLOSE: 'post*c.close',
      },
    },
    GNB: {
      MYASSET: 'gnb.myasset',
      REALESTATE: 'gnb.realestate',
      SETTING: 'gnb.setting',
    },
    MENU: {
      NOTIFY: 'menu.push',
      SETTING: 'menu.setting',
    },
    LIST: {
      TAB: 'list.tab',
      ADD: 'list.addhome',
      LIMIT: {
        SETTING: 'list*p.settinggo',
        CLOSE: 'list*p.close',
      },
    },
    NO_HOME_GUIDE: {
      ADD: 'noh.addhome',
    },
    MAIN_INFO: {
      PRICE_TOOLTIP: 'info.reptooltip',
      OFFICE: 'info.office',
      OFFICE_CALL: 'info.officecall',
      COMPLEX_INFO: 'info.complex',
      RESALE_TOOLTIP: 'info.ltstooltip',
      DETAIL_ADDRESS: 'info.enteraddress',
      DETAIL_ADDRESS_TOOLTIP_CLOSE: 'info.addresstooltipclose',
      BUY_DATE: 'info.enterbuydate',
      MOVE_DATE: 'info.entermovedate',
      AUTHENTICATION_GUIDE: {
        OWNER: 'info.myhouseguide',
        RESIDENT: 'info.tenantguide',
        OWNER_FAIL_RETRY: 'info.ownerfailureguide',
        RESIDENT_FAIL_RETRY: 'info.tenantfailureguide',
        RESIDENTIAL_ADD_HOME: 'info.addhome',
        EXPIRE_DATE_DELETE: 'info.housedelete',
        EXPIRE_DATE_MODIFY: 'info.expirydateedit',
      },
    },
    REAL_PRICE: {
      TOOLTIP: 'rep.tooltip',
      DEAL: 'rep.sell',
      RENT: 'rep.rent',
      LEASE: 'rep.monthly',
      YEAR_1: 'rep.1year',
      YEAR_3: 'rep.3year',
      YEAR_5: 'rep.5year',
      YEAR_7: 'rep.7year',
      MORE: 'rep.more',
    },
    // 호별시세
    UNIT_TREND_PRICE: {
      TOOLTIP: 'dtd.tooltip',
      MORE: 'dtd.more',
      MOBILE_POPUP: 'dtd.mobile',
      DETAIL_ADDRESS: 'dtd.address',
      AUTHENTICATION: 'dtd.confirmation',
    },
    // 공시 가격
    UNIT_LAND_PRICE: {
      TOOLTIP: 'orep.tooltip',
      MORE: 'orep.more',
    },
    SAME_ARTICLE: {
      LIST: 'sam.list',
      MORE: 'sam.more',
    },
    SIMILAR_ARTICLE: {
      LIST: 'sim.list',
      MORE: 'sim.more',
      SETTING: 'sim*g.setting',
    },
    //시세 없음. 지도에서 다른 매물 정보 찾기
    NOT_PRICE_MORE: 'nop.more',
    TAX: {
      TOOLTIP: 'tax.tooltip',
      PAY: 'tax.pay',
      DETAIL: 'tax.readmore',
      REFRESH: 'tax.refreshify',
      MORE: 'tax.moretax',
      MOVE_INVOICE_LINK: 'tax.navertaxgo',
      WETAX: 'tax.seoul',
      ETAX: 'tax.countrywide',
      NAVER_APP_GUIDE: 'tax.naverapp',
    },
    MAIN_MANAGEMENT_FEE: {
      TOOLTIP: 'cost.tooltip',
      PYEONG: 'cost.py',
      M2: 'cost.m2',
      AVERAGE_MORE: 'cost.averagemore',
      MONTHLY_MORE: 'cost.monthmore',
    },
    MAIN_NOTICE: {
      ENROL: 'noti.posting',
      DETAIL: 'noti.list',
      MORE: 'noti.more',
      EMPTY_NOTICE_ENROL: 'noti.nonoticeguide',
    },
    NOTICE_LIST: {
      ENROL: 'noti*l.posting',
      TAB: {
        ALL: 'noti*l.all',
        OFFICE: 'noti*l.office',
        MEETING: 'noti*l.residentcommittee',
        TENANT: 'noti*l.residents',
        GOVERNMENT: 'noti*l.municipal',
        ETC: 'noti*l.etc',
      } as NCLICK_TYPE,
      DETAIL: 'noti*l.list',
      BACK: 'noti*l.back',
    },
    NOTICE_DETAIL: {
      IMAGE_VIEWER: 'noti*d.img',
      EDIT: 'noti*d.edit',
      DELETE: 'noti*d.delete',
      DELETE_POPUP: 'noti*d.deletepopup',
      REPORT: 'noti*d.complain',
      PREVIOUS_POST: 'noti*d.previouspost',
      NEXT_POST: 'noti*d.nextpost',
      LIST: 'noti*d.list',
      BACK: 'noti*d.back',
    },
    NOTICE_ENROL: {
      NOTICE_TYPE: 'noti*p.noticetype',
      NOTICE_TYPE_SELECT: {
        OFFICE: 'noti*p.noticetype1',
        MEETING: 'noti*p.noticetype2',
        TENANT: 'noti*p.noticetype3',
        GOVERNMENT: 'noti*p.noticetype4',
        ETC: 'noti*p.noticetype5',
      } as NCLICK_TYPE,
      TITLE: 'noti*p.title',
      CONTENT: 'noti*p.text',
      IMAGE_ATTACH: 'noti*p.img',
      IMAGE_TOOLTIP_CLOSE: 'noti*p.imgtooltipclose',
      IMPORTANT: 'noti*p.important',
      SECURITY: 'noti*p.security',
      SECURITY_TOOLTIP: 'noti*p.securitytooltip',
      COPYABLE: 'noti*p.copy',
      NAVER_PROFILE_URL: 'noti*p.naverinfogo',
      COMPLETE: 'noti*p.complete',
      CANCEL: 'noti*p.cancel',
    },
    MAIN_REVIEW: {
      ENROL: 'rev.posting',
      DETAIL: 'rev.list',
      MORE: 'rev.more',
      EMPTY_REVIEW_ENROL: 'rev.noreviewguide',
    },
    REVIEW_LIST: {
      ENROL: 'rev*l.posting',
      DETAIL: 'rev*l.list',
      BACK: 'rev*l.back',
    },
    REVIEW_DETAIL: {
      IMAGE_VIEWER: 'rev*d.img',
      EDIT: 'rev*d.edit',
      DELETE: 'rev*d.delete',
      DELETE_POPUP: 'rev*d.deletepopup',
      REPORT: 'rev*d.complain',
      PREVIOUS_POST: 'rev*d.previouspost',
      NEXT_POST: 'rev*d.nextpost',
      LIST: 'rev*d.list',
      BACK: 'rev*d.back',
    },
    REVIEW_ENROL: {
      CONTENT: 'rev*p.text',
      IMAGE_ATTACH: 'rev*p.img',
      COPYABLE: 'rev*p.copy',
      NAVER_PROFILE_URL: 'rev*p.naverinfogo',
      COMPLETE: 'rev*p.complete',
      CANCEL: 'rev*p.cancel',
    },
    NOTIFY: {
      NOTIFY_YN: 'push.onoff',
      ARTICLE: 'push.property',
      REAL_PRICE: 'push.rtlp',
      EXPIRE: 'push.rent',
      NOTICE_ESSENTIAL: 'push.importantnotice',
      NOTICE_BASE: 'push.notice',
      TOOLTIP: {
        ARTICLE: 'push.propertytooltip',
        REAL_PRICE: 'push.rtlptooltip',
      },
      EXPIRE_INPUT: 'push.enterexpirydate',
      COMPLETE: 'push.complete',
    },
    SETTING: {
      ADD: 'set.add',
      DELETE: 'set.delete',
      MOVE: 'set.move',
      EDIT: 'set.edit',
      OWNER_AUTHENTICATION: 'set.myhouse',
      RESIDENT_AUTHENTICATION: 'set.tenant',
      WITHDRAWAL: 'set.cancel',
      COMPLETE: 'set.complete',
      POPUP: {
        ADD_LIMIT: 'set*p.notadd',
        DELETE: 'set*p.delete',
      },
    },
    REGISTER_EDIT: {
      ADDRESS_CHANGE: 'edit.address',
      REALESTATE_TYPE: 'edit.hometype',
      REALESTATE_TYPE_SELECT: {
        A01: 'edit.hometype1',
        A02: 'edit.hometype2',
        C02: 'edit.hometype3',
        C03: 'edit.hometype4',
        D05: 'edit.hometype5',
        D02: 'edit.hometype6',
        D03: 'edit.hometype7',
      } as NCLICK_TYPE,
      PYEONG_SELECT: 'edit.pyselect',
      DEAL: 'edit.sell',
      LEASE: 'edit.rent',
      RENT: 'edit.monthly',
      INPUT: {
        DEAL_PRICE: 'edit.sellprice',
        DEAL_DEPOSIT: 'edit.selldeposit',
        DEAL_DATE: 'edit.selldate',
        LEASE_DEPOSIT: 'edit.rentdeposit',
        LEASE_MOVE_DATE: 'edit.rentmovedate',
        LEASE_EXPIRE_DATE: 'edit.rentexpirydate',
        RENT_DEPOSIT: 'edit.monthlydeposit',
        RENT_PRICE: 'edit.monthlyprice',
        RENT_MOVE_DATE: 'edit.monthlymovedate',
        RENT_EXPIRE_DATE: 'edit.monthlyexpirydate',
      },
      TERM: {
        ALL: 'edit.allterms',
        COLLECT: 'edit.terms1',
        DISCLOSURE: 'edit.terms2',
        COLLECT_MORE: 'edit.terms1more',
        DISCLOSURE_MORE: 'edit.terms2more',
      },
      COMPLETE: 'edit.complete',
      CLOSE: 'edit.close',
      POPUP: {
        CHANGE_ADDRESS: 'edit*p.address',
        CHANGE_TO_DEAL: 'edit*p.owner',
        CHANGE_DEAL_TO_OTHER: 'edit*p.ownercancel',
      },
    },
    WITHDRAWAL: {
      SHOW_POPUP: 'ccl.cancel',
      BACK: 'ccl.back',
      POPUP: {
        WITHDRAWAL: 'ccl*p.servicewithdraw',
        CANCEL: 'ccl*p.cancel',
      },
    },
  },
}

// 페이지 기준
export const NDS_PROTOCOL = {
  MY_HOUSE: {
    REGISTER: {
      ADDRESS_SEARCH_PAGE: 'myhouse.register.address',
      COMPLEX_PAGE: 'myhouse.register.complex',
      NOCOMPLEX_PAGE: 'myhouse.register.noncomplex',
      PYEONG_PAGE: 'myhouse.register.pyeong',
      MAIN: 'myhouse.register.main',
      TERM_COLLECT: 'myhouse.register.term.collect',
      TERM_DISCLOSURE: 'myhouse.register.term.disclosure',
    },
    ADD_HOME_RESULT_AUTHENTICATION_GUIDE: {
      OWNER: 'myhouse.register.result.owner',
      RESIDENT: 'myhouse.register.result.resident',
      BUILDING: 'myhouse.register.result.store',
      OWNER_NO_INFO: 'myhouse.register.result.owner.nocontents',
      RESIDENT_NO_INFO: 'myhouse.register.result.resident.nocontents',
    },
    AUTHENTICATION: {
      SELECT_AUTH_TYPE: 'myhouse.auth.selectmethod',
      OWNER: 'myhouse.auth.owner',
      RESIDENT: 'myhouse.auth.resident',
      RESIDENT_TERM: 'myhouse.auth.resident.term',
      RESIDENT_TERM_COLLECT: 'myhouse.auth.resident.term.collect',
      FEE: 'myhouse.auth.managementfee.intro',
      FEE_CONFIRM: 'myhouse.auth.managementfee.check',
      PACKAGE: 'myhouse.auth.package.intro',
      PACKAGE_CONFIRM: 'myhouse.auth.package.check',
    },
    HOME: {
      MAIN: 'myhouse.main',
      NOTIFY: 'myhouse.notify.settings',
      SETTING: 'myhouse.regist.settings',
      EDIT: 'myhouse.register.main',
      WITHDRAWAL: 'myhouse.settings.withdrawal',
      NO_HOME_GUIDE: 'myhouse.regist.guide',
    },
    NOTICE: {
      LIST: 'myhouse.complexes.notice.list',
      DETAIL: 'myhouse.complexes.notice.detail',
      ENROL: 'myhouse.complexes.notice.enrol',
      MODIFY: 'myhouse.complexes.notice.modify',
    },
    REVIEW: {
      LIST: 'myhouse.complexes.review.list',
      DETAIL: 'myhouse.complexes.review.detail',
      ENROL: 'myhouse.complexes.review.enrol',
      MODIFY: 'myhouse.complexes.review.modify',
    },
  },
}
